import Root from "../layouts/Root";
import GamesTable from "../components/games/GamesTable";
import IconText from "../components/IconText";
import {faMobile} from "@fortawesome/free-solid-svg-icons/faMobile";
import iconGames from "../assets/img/icon-games.png";

export default function Games() {
    const rightContent = (
        <div>
            <h1><IconText icon={faMobile} text={"Mobile"}/></h1>
            <GamesTable/>
        </div>
    )
    return (
        <div className="games-page">
            <Root rightContent={rightContent} icon={iconGames}/>
        </div>
    )
}
